import { render, staticRenderFns } from "./ClassificationCard.vue?vue&type=template&id=3633b04e&scoped=true&"
import script from "./ClassificationCard.vue?vue&type=script&lang=js&"
export * from "./ClassificationCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationCard.vue?vue&type=style&index=0&id=3633b04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633b04e",
  null
  
)

export default component.exports